import { InputComponent } from "components/components/Component";
import { DateInputBaseDefinition, DateInputBaseComponent } from "components/input/baseInputDefinition";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import template from "./dateTime.hbs";
import "./dateTime.scss";
import { DateTimeInputElement, initDateTimeInputWebComponent } from "./dateTimeElement";

initDateTimeInputWebComponent();

export class DateTimeInput extends DateInputBaseComponent<DateTimeInputDefinition> implements InputComponent {

    public readonly componentType: string = "dateTimeInput";

    private element: DateTimeInputElement;

    constructor(schema: DateTimeInputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();
        ComponentActionHelper.register(this);
        return this.view;
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    private bindEvents(): void {

        this.element = this.view.querySelector("s6-date-time-input");

        this.genericBindEvents(this.element, false);
    }

    public getValue(): Date {
        return this.element.data;
    }

    public value(v: string | Date) {
        if ((v == null) || ((v as unknown) === "")) {
            this.element.data = null;
        } else {
            this.element.data = new Date(v);
        }
    }

    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }

    public setValidationStatus(valid: boolean, message?: string) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }
}

export interface DateTimeInputDefinition extends DateInputBaseDefinition {
}
